import React, { Component } from "react";
import Downshift from "downshift";
import debounce from 'lodash.debounce';
import AddDirectorInline from './AddDirectorInline.js';
import { getFirestore, query, where, collection, getDocs } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

// https://codesandbox.io/examples/package/downshift
// https://codesandbox.io/s/1rj327v2jj

// state is passed up via props.handler
export default class DirectorAutocomplete extends Component {
    constructor(props) {
        super(props);

        const sc = this.props.showCreateOption === true ? true : false;
        this.state = { directors: [], loading: false, showCreateOption: sc, showCreateInterface: false, currentSearchTerm: undefined };
        this.fetchDirectors = this.fetchDirectors.bind(this);
        this.handleAddDirectorChange = this.handleAddDirectorChange.bind(this);
        this.inputOnChange = this.inputOnChange.bind(this);
        this.handlerFunc = this.handlerFunc.bind(this);

        this.emitChangeDebounced = debounce(this.inputOnChange, 300);

        const config = {
            apiKey: "AIzaSyD6RfNtDIEKhjXpzeWnBW_xUZjgFkILSeI",
            authDomain: "findflix-1e61f.firebaseapp.com",
            projectId: "findflix-1e61f",
            storageBucket: "findflix-1e61f.appspot.com",
            messagingSenderId: "21082022876",
            appId: "1:21082022876:web:4f6232412df3097d6da519",
            measurementId: "G-Z86DHZV8TV"
        };
        const firebaseApp = initializeApp(config);
        this.db = getFirestore(firebaseApp);
    }

    handlerFunc(p1) {
        this.props.handler(p1, this.props.sfv, this.props.sft)
    }

    inputOnChange(event) {
        if (!event.target.value) {
            this.setState({ directors: [] });
            return;
        }

        this.setState({ currentSearchTerm: event.target.value });
        this.fetchDirectors(event.target.value);
    }

    downshiftOnChange(selectedDirector) {
        console.log(`[DirectorAutocomplete] selected director ${selectedDirector.id} / ${selectedDirector.name}`);

        if (selectedDirector.id === '0') {
            console.log("[DirectorAutocomplete] show create director interface");
            this.setState({ showCreateInterface: true });
        } else {
            // lift state upwards
            console.log(`[DirectorAutocomplete] lift selected director upwards ${selectedDirector.id}`);
            this.handlerFunc(selectedDirector);
        }
    }

    // handles the fetch from firestore
    async nameSearch(searchTerm) {
        // console.log("[DirectorAutocomplete] nameSearch() " + searchTerm);

        const directorsCollection = collection(this.db, "directors");
        const queryFilter = query(directorsCollection, where("name", ">=", searchTerm), where("name", "<=", searchTerm + '\uf8ff'));
        const querySnapshot = await getDocs(queryFilter);
        const directorsArray = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
        return directorsArray;
    }

    async fetchDirectors(searchTerm) {
        // console.log("[DirectorAutocomplete] fetchDirectors() " + searchTerm);

        if (searchTerm === undefined || searchTerm === null || searchTerm.trim() === '') {
            return
        }

        this.setState({ loading: true });
        var re = [];
        const searchResults = await this.nameSearch(searchTerm);
        if (searchResults.length > 0) {
            re.push(...searchResults);
        } else {
            re = [];
        }
        if (this.state.showCreateOption === true) {
            re.push({ id: '0', name: 'Create new record' })
        }
        this.setState({ directors: re });
        this.setState({ loading: false });
    }

    // LIFTING STATE FROM director addinline

    handleAddDirectorChange(selectedDirector) {
        console.log("[DirectorAutocomplete] handleAddDirectorChange() " + JSON.stringify(selectedDirector));
        this.setState({ showCreateInterface: false });
        this.handlerFunc(selectedDirector);
    }

    render() {
        return (
            <>
                <AddDirectorInline open={this.state.showCreateInterface} onChange={this.handleAddDirectorChange} autoc={this.state.currentSearchTerm} />
                <Downshift onChange={this.downshiftOnChange.bind(this)} itemToString={item => (item ? item.name : "")} >
                    {({
                        selectedItem,
                        getInputProps,
                        getItemProps,
                        highlightedIndex,
                        isOpen,
                        // inputValue
                    }) => (
                        <div className="relative">
                            <div className='absolute top-3 right-2'>
                                {this.state.loading && <img src='/images/loadingtiny.gif' width='16' height='16' alt='' />}
                            </div>
                            <input className="w-full p-2 text-sm focus:outline-none focus:shadow-outline rounded border border-gray-300 focus:ring-1 focus:ring-isober-500 focus:border-isober-500"
                                {...getInputProps({
                                    placeholder: "Start typing...",
                                    onChange: this.emitChangeDebounced
                                })}
                            />
                            {isOpen ? (
                                <div className="border border-gray-300 bg-white shadow-md">
                                    {this.state.directors
                                        .slice(0, 10)
                                        .map((item, index) => (
                                            <div
                                                className="dropdown-item"
                                                {...getItemProps({ key: index, index, item })}
                                                style={{
                                                    backgroundColor: highlightedIndex === index ? "lightgray" : "white",
                                                    fontWeight: selectedItem === item ? "bold" : "normal"
                                                }}
                                            >
                                                {item.name}
                                            </div>
                                        ))}
                                </div>
                            ) : null}
                        </div>

                    )}
                </Downshift>
            </>
        );
    }
}